import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageDivonne: React.FC = () => (
  <LocalSeoPage
    city="Divonne-les-Bains"
    cityShort="Divonne"
    slug="depannage-informatique-divonne-les-bains"
    metaTitle="Dépannage Informatique Divonne-les-Bains | SOS IT"
    metaDescription="Technicien informatique à Divonne-les-Bains. Réparation PC, suppression virus, WiFi. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur ne fonctionne plus à Divonne-les-Bains ? Nous intervenons rapidement, à domicile ou à distance. PC lent, virus, panne WiFi, imprimante en panne ou Windows bloqué — on s'en occupe. Diagnostic 100 % gratuit, sans engagement."
    postalCode="01220"
    nearbyTowns={[
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Thoiry' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Prévessin-Moëns', href: '/depannage-informatique-prevessin-moens' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageDivonne;
